import { mapState, mapActions } from 'vuex';
import lang from './exchange-rate-afir-lang.json';
import exchangeRateAfirForm from './exchange-rate-afir-form/exchange-rate-afir-form.vue';
import exchangeRateAfirResults from './exchange-rate-afir-results/exchange-rate-afir-results.vue';
import modal from '../../common/components/modal/modal.vue';
import moment from 'moment';
import { BACKEND_DATE_FORMAT } from '../../common/js/constants/constants.js';
export default {
	data() {
		return {};
	},
	locales: lang,
	components: {
		'exchange-rate-afir-form': exchangeRateAfirForm,
		'exchange-rate-afir-results': exchangeRateAfirResults,
		modal
	},
	computed: {
		...mapState('exchangeRateAfir', ['technicalError', 'loading', 'versionInfo', 'results', 'version', 'date', 'currencies', 'messages'])
	},
	methods: {
		dateChanged(date) {
			this.setDate(date);
			this.getVersions({ date });
		},
		...mapActions('exchangeRateAfir', [
			'setDate',
			'getVersions',
			'setVersion',
			'calculate',
			'resetResults',
			'getCurrencies',
			'setTechnicalError',
			'getMessages'
		])
	},
	created() {
		this.dateChanged(moment(new Date()).format(BACKEND_DATE_FORMAT));
	}
};
